import { Separator } from '@heroui/react';
import { InlineDateRangeSection } from '../../../components/ui/inline-date-range-section';
import { UsageTypeCheckboxGroup } from '../../../components/ui/usage-type-checkbox-group';
import {
  detectAvailableSpotsPeriodPreset,
  type AvailableSpotsPeriodSelection,
} from '../utils/available-spots-period-presets';
import { AvailableSpotsPeriodPresets } from './available-spots-period-presets';

export interface AvailableSpotsFiltersState {
  startDate: string;
  endDate: string;
  periodPresetId: AvailableSpotsPeriodSelection;
  filterBorrow: boolean;
  filterRent: boolean;
}

interface AvailableSpotsFiltersFormProps {
  filters: AvailableSpotsFiltersState;
  onChange: (next: AvailableSpotsFiltersState) => void;
}

export function AvailableSpotsFiltersForm({
  filters,
  onChange,
}: AvailableSpotsFiltersFormProps) {
  const patch = (partial: Partial<AvailableSpotsFiltersState>) =>
    onChange({ ...filters, ...partial });

  const selectedPresetId = detectAvailableSpotsPeriodPreset(filters.startDate, filters.endDate);

  return (
    <div className="flex flex-col gap-5">
      <AvailableSpotsPeriodPresets
        selectedPresetId={selectedPresetId}
        startDate={filters.startDate}
        endDate={filters.endDate}
        onSelectPreset={(presetId, startDate, endDate) =>
          patch({ periodPresetId: presetId, startDate, endDate })
        }
      />

      <div className="flex items-center gap-3">
        <Separator className="flex-1" />
        <span className="text-xs uppercase tracking-wide text-muted">ou</span>
        <Separator className="flex-1" />
      </div>

      <InlineDateRangeSection
        title="Período no calendário"
        startDate={filters.startDate}
        endDate={filters.endDate}
        onChange={(startDate, endDate) =>
          patch({
            startDate,
            endDate,
            periodPresetId: detectAvailableSpotsPeriodPreset(startDate, endDate),
          })
        }
      />

      <UsageTypeCheckboxGroup
        inCard={false}
        requireAtLeastOne
        label="Tipo de uso"
        description="Marque pelo menos um tipo de vaga que deseja buscar."
        borrowSelected={filters.filterBorrow}
        rentSelected={filters.filterRent}
        onChange={(filterBorrow, filterRent) => patch({ filterBorrow, filterRent })}
      />
    </div>
  );
}
